/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RateUpdateType = {
    Internal: 'INTERNAL',
    External: 'EXTERNAL',
    InternalAutoSave: 'INTERNAL_AUTO_SAVE',
    ExternalAutoSave: 'EXTERNAL_AUTO_SAVE',
    ExternalBoost: 'EXTERNAL_BOOST'
} as const;
export type RateUpdateType = typeof RateUpdateType[keyof typeof RateUpdateType];


export function instanceOfRateUpdateType(value: any): boolean {
    for (const key in RateUpdateType) {
        if (Object.prototype.hasOwnProperty.call(RateUpdateType, key)) {
            if (RateUpdateType[key as keyof typeof RateUpdateType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RateUpdateTypeFromJSON(json: any): RateUpdateType {
    return RateUpdateTypeFromJSONTyped(json, false);
}

export function RateUpdateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateUpdateType {
    return json as RateUpdateType;
}

export function RateUpdateTypeToJSON(value?: RateUpdateType | null): any {
    return value as any;
}

export function RateUpdateTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): RateUpdateType {
    return value as RateUpdateType;
}

